/**
 * This fixes Google closure compiler's symbol polyfill + IE11 bug, filtering out property names
 * starting with "$jscomp_hidden".
 */
export default (getOwnPropertyNames => obj => {
  const names = getOwnPropertyNames(obj);
  return names.filter(n => n.indexOf('$jscomp_hidden') !== 0);
})(Object.getOwnPropertyNames);
